import { forwardRef, useContext, useState } from 'react';

import { doctorFilter } from '../../actions/mainForm';
//services
// import { obtenerMedicos } from '../../services/api';

//components
import ExportarExcel from './ExportarExcel';
import MedicoDialog from './MedicoDialog';
import InstitucionDialog from './Institucion/InstitucionDialog';

import { DataContext } from '../../context/DataContext';

//Helpers
import { valMsg } from '../../helpers/swal_msg';
// hook
import useFetchHook from '../../hooks/customHook';

//MUI
import { Box, Button, Container, InputAdornment, TextField, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Edit, Business } from '@mui/icons-material';

//Datepicker
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { es } from 'date-fns/locale';

//React table
import { MaterialReactTable, MRT_ActionMenuItem } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';

import { DOCTOR_DEFAULT } from '../../constants/form_const';

const columns = [
    {
        accessorKey: `${['name']}`,
        header: 'Nombre',
        size: 150,
    },
    {
        accessorKey: `${['registration_date']}`,
        header: 'Fecha de registro',
        size: 200,
    },
    {
        accessorKey: `${['promotor_name']}`,
        header: 'Nombre del promotor',
        size: 150,
    },
    {
        accessorKey: `${['institution_counter']}`,
        header: 'No. Instituciones',
        size: 150,
    },
];

const MedicosList = () => {
    const { data: { institution_types }, setData } = useContext(DataContext);

    const { protectedFetchReq } = useFetchHook();

    const [medicos, setMedicos] = useState([]);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    // diálogo edición médico, diálogo edición instituciones
    const [dialogStatus, setDialogStatus] = useState({
        dialog1: false, dialog2: false, dialog3: false, dialog4: false
    });
    const { dialog1 } = dialogStatus;
    // médico a editar
    const [doctor, setDoctor] = useState(DOCTOR_DEFAULT);
    // instituciones a editar
    const [doctorInstitutions, setDoctorInstitutions] = useState({
        idMedicoEspecialista: 0, institutions: []
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (fechaInicio && fechaFin) {
            setMedicos(
                await doctorFilter({ fechaInicio, fechaFin }, setData, protectedFetchReq)
            );
        } else
            valMsg('error', 'Por favor, seleccione un rango de fechas');
    };

    const doctorEdit = (row, closeMenu) => () => {
        if (row) {
            const {
                idMedicoEspecialista, name, professionalID,
                email, phone, especialidad, promotor_name
            } = row;
            closeMenu();
            setDoctor(e => ({
                ...e,
                idMedicoEspecialista, name, professionalID,
                email, phone, especialidad, promotor_name
            }));
            setDialogStatus(e => ({ ...e, dialog1: true }));
        }
    };

    const hospitalEdit = (row, closeMenu) => () => {
        if (row) {
            const { idMedicoEspecialista, institutions } = row;
            setDoctorInstitutions({ idMedicoEspecialista, institutions });
            closeMenu();
            setDialogStatus(e => ({ ...e, dialog2: true }));
        }
    };

    const ExampleCustomInput = forwardRef(
        ({ value, onClick, className }, ref) => (
            <Button variant='outlined' sx={{ textTransform: 'none' }} className={className} onClick={onClick} ref={ref} endIcon={<CalendarMonthIcon />}>
                {
                    value === ''
                        ?
                        'Seleccione un rango de fecha'
                        :
                        <>{value}</>
                }
            </Button>
        ),
    );

    const onChange = (dates) => {
        const [start, end] = dates;
        setFechaInicio(start);
        setFechaFin(end);
    };

    return (
        <Container maxWidth='xxl' sx={{ my: 5 }}>
            <Typography variant='h4' gutterBottom>Lista de Médicos</Typography>

            {/* Formulario de fechas */}
            <form onSubmit={handleSubmit}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
                    <DatePicker
                        selected={fechaInicio}
                        onChange={(date) => setFechaInicio(date)}
                        locale={es}
                        selectsStart
                        startDate={fechaInicio}
                        endDate={fechaFin}
                        customInput={<TextField label="Fecha de inicio"
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end"><CalendarMonthIcon /></InputAdornment>,
                                },
                            }}
                        />}
                        required
                    />
                    <DatePicker
                        selected={fechaFin}
                        onChange={(date) => setFechaFin(date)}
                        locale={es}
                        selectsEnd
                        startDate={fechaInicio}
                        endDate={fechaFin}
                        minDate={fechaInicio}
                        customInput={<TextField label="Fecha de fin"
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end"><CalendarMonthIcon /></InputAdornment>,
                                },
                            }}
                        />}
                        required
                    />
                    <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>
                        Buscar Médicos
                    </Button>
                </Box>
            </form>

            <Box sx={{ mt: 5 }}>
                <MaterialReactTable data={medicos} columns={columns} localization={MRT_Localization_ES}
                    renderTopToolbarCustomActions={() => (
                        <ExportarExcel medicos={medicos} />
                    )}
                    enableRowActions
                    renderRowActionMenuItems={({ row, table, closeMenu }) => [
                        <MRT_ActionMenuItem
                            icon={<Edit />}
                            key="doctor-edit"
                            label="Actualizar médico"
                            onClick={doctorEdit(row.original, closeMenu)}
                            table={table}
                        />,
                        <MRT_ActionMenuItem
                            icon={<Business />}
                            key="hospital-edit"
                            label="Modificar instituciones"
                            onClick={hospitalEdit(row.original, closeMenu)}
                            table={table}
                        />
                    ]}
                />
            </Box>

            <MedicoDialog
                open={dialog1}
                setDialogStatus={setDialogStatus}
                doctor={doctor}
                setDoctor={setDoctor}
                setMedicos={setMedicos}
            />
            <InstitucionDialog
                dialogStatus={dialogStatus}
                setDialogStatus={setDialogStatus}
                doctorInstitutions={doctorInstitutions}
                setDoctorInstitutions={setDoctorInstitutions}
                setMedicos={setMedicos}
                institution_types={institution_types}
            />
        </Container>
    );
};

export default MedicosList;